import { ScrollRestoration, Outlet } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AppProvider } from './context';
import { queryClient } from './services';
import { BackdropLoading, InstallAppModal, Snackbar } from './design-system';
import { useSaveFiltersControlEffect, useVhControlEffect, usePwaAutoInstall } from './hooks';

export const App = () => {
  useSaveFiltersControlEffect();
  useVhControlEffect();
  usePwaAutoInstall();

  return (
    <AppProvider>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Outlet />
          <ScrollRestoration />
          <BackdropLoading />
          <Snackbar />
          <InstallAppModal />
        </LocalizationProvider>
      </QueryClientProvider>
    </AppProvider>
  );
};
